import { render, staticRenderFns } from "./cameraDetailInfo.vue?vue&type=template&id=3f794c16&scoped=true&"
import script from "./cameraDetailInfo.vue?vue&type=script&lang=js&"
export * from "./cameraDetailInfo.vue?vue&type=script&lang=js&"
import style0 from "./cameraDetailInfo.vue?vue&type=style&index=0&id=3f794c16&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f794c16",
  null
  
)

export default component.exports